import React from 'react';
import { BankInfo } from './BankInfo';
import { userService } from '../../_services';
import { OccupationInfo } from './OccupationInfo';

export class WireInfo extends React.Component{

    constructor(props){
        super(props);

        const {memberBanks , verificationStatementImageUrl , memberProfileData} = this.props ; 

        this.state = {
            disableSubmit : false ,
            memberBank1 : null , 
            memberBank2 : null , 
            file : null ,  
            filename : 'Statement Image' , 
            verificationStatementImageUrl : '' , 
            occpIncomeSrc : '' , 
            occpWorkNature :  '' , 
            occpPosition :   '' , 
            occpCompanyName : '' , 
            occpAnnualIncome : '' 
            
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMemberBankUpdate = this.handleMemberBankUpdate.bind(this);
        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    
    componentWillReceiveProps(nextProps){
        if(nextProps.memberBanks != this.props.memberBanks){
            //assign memberbanks to children state 
            this.setState({
                memberBank1 : nextProps.memberBanks.length > 0 ? nextProps.memberBanks[0] : null , 
                memberBank2 : nextProps.memberBanks.length > 1 ? nextProps.memberBanks[1] : null , 
            })
        }

        if(nextProps.verificationStatementImageUrl != this.props.verificationStatementImageUrl){
            this.setState({
                verificationStatementImageUrl : nextProps.verificationStatementImageUrl
            })
        }

        if(nextProps.memberProfileData != this.props.memberProfileData){
            this.setState({
                
                occpIncomeSrc : nextProps.memberProfileData.occpIncomeSrc  , 
                occpWorkNature :  nextProps.memberProfileData.occpWorkNature , 
                occpPosition :   nextProps.memberProfileData.occpPosition , 
                occpCompanyName :  nextProps.memberProfileData.occpCompanyName , 
                occpAnnualIncome :  nextProps.memberProfileData.occpAnnualIncome
            })
        }
    }
    
    handleChange(event){
        this.setState({
            [event.target.name] : event.target.value
        });
    }

    handleMemberBankUpdate(memberbank , iteration){

        this.setState({
          [`memberBank${iteration}`] : memberbank
        })
    }

    handleUploadFile (event){
        let file = event.target.files[0];

        if(file){
            this.setState ({
                filename : file.name ,
                file : file 
            });
        }

        //display image 
        let reader = new FileReader();

        reader.onload = (e) => {
            this.setState({verificationStatementImageUrl: e.target.result});
        };
        reader.readAsDataURL(event.target.files[0]);
    }


    handleSubmit(event){
        event.preventDefault();

        //gather states and perform Post 
        const { memberBank1 , memberBank2 , file , 
            occpAnnualIncome , 
            occpIncomeSrc , 
            occpPosition , 
            occpWorkNature , 
            occpCompanyName 
        } = this.state; 

        let memberBanks = []; 
        
        if(memberBank1) memberBanks.push(memberBank1);
        if(memberBank2) memberBanks.push(memberBank2);
        
        let formBody = {
            memberBanks : memberBanks , 
            memberId : this.props.memberId , 
            occpAnnualIncome : occpAnnualIncome , 
            occpIncomeSrc :occpIncomeSrc  , 
            occpPosition : occpPosition , 
            occpWorkNature : occpWorkNature , 
            occpCompanyName : occpCompanyName
        }

        this.setState({
            disableSubmit : true
        });

        userService.updateWireInformation(formBody , file);
    }


    render(){
        const { disableSubmit , memberBank1 , memberBank2 , verificationStatementImageUrl , 
            occpAnnualIncome , occpCompanyName , occpIncomeSrc , occpPosition , occpWorkNature  } = this.state;


        return (
            <section className="">
                
                <div className="container">
                    <form onSubmit={this.handleSubmit} className="default-form is-clearfix">
                        <div className="columns">
                            <div className="column is-6 border-right p-r-lg">
                                <h4>Wire Information</h4>

                                <h4 className="border-bottom p-t-md">Bank Account 1</h4>
                                <BankInfo memberBank = {memberBank1} handleMemberBankUpdate={this.handleMemberBankUpdate} iteration="1"/>

                                <h4 className="border-bottom p-t-xs">Bank Account 2 (Optional)</h4>
                                <BankInfo memberBank = {memberBank2} handleMemberBankUpdate={this.handleMemberBankUpdate} iteration="2"/>
                            </div>
                            

                            <div className="column is-6">
                                <h4>Occupation</h4>

                                <OccupationInfo 
                                    occpAnnualIncome = {occpAnnualIncome} 
                                    occpCompanyName = {occpCompanyName}
                                    occpIncomeSrc = {occpIncomeSrc}
                                    occpPosition = {occpPosition}
                                    occpWorkNature = {occpWorkNature}
                                    handleChange = {this.handleChange}
                                />

                                <hr/>

                                <h4>Proof of Address</h4>
                                
                                <div className="field is-horizontal m-t-md">
                                    *Upload Bank Statements or Utility Bills 
                                </div>

                                <div className="field is-horizontal m-t-md">
                                    <div className="field-label is-small">
                                        <label className="label">Upload Bank Statements or Utility Bills</label>
                                    </div>
                                    <div className="field-body">
                                        <div className="file has-name is-right">
                                            <label className="file-label">
                                                <input onChange={this.handleUploadFile} className="file-input" type="file" name="filename" />
                                                <span className="file-cta ">
                                                    <span className="file-icon">
                                                        <i className="fas fa-upload"></i>
                                                    </span>
                                                    <span className="file-label">
                                                        Choose a file…
                                                    </span>
                                                </span>
                                                <span className="file-name">
                                                    {this.state.filename}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="field is-horizontal m-t-md">
                                    <div className="field-label is-small">
                                        <label className="label">Statement/bill Image</label>
                                    </div>
                                    <div className="field-body">
                                        <img src={verificationStatementImageUrl} className="holder-upload-image" name="verificationStatementImageUrl"/>
                                    </div>
                                </div>
                                <div className="control is-pulled-right m-t-lg">
                                    <input type="submit" disabled={disableSubmit} className="button button-submit" value="Save Wire Information"/>
                                </div>
                            </div>
                                
                        </div>
                    </form>
                </div>

            </section>
        )
    }

}


// WEBPACK FOOTER //
// ./src/Views/ProfilePage/WireInfo.jsx